import React, { Component } from 'react';
import ActionModal, { ActionModalFooter } from 'common-components/modal/ActionModal';
import { notification } from 'antd';
import { Paragraph } from 'common-components/typography';
import { GhostButton, PrimaryButton } from 'common-components/buttons';
import CommonUtils from 'utilities/common-utils';
import { ClaimType } from 'utilities/enum-utils';

interface ChargeGroupBookingCancellationFeeModalProps {
  isOpen: any;
  onClose: any;
  booking: any;
  doChargeGroupBookings: any;
}
interface ChargeGroupBookingCancellationFeeModalState {
  step: number;
  canManuallyClose: boolean;
  title: string;
  startDateTime: Date;
  isLoading: boolean;
}

export class ChargeGroupBookingCancellationFeeModal extends Component<
  ChargeGroupBookingCancellationFeeModalProps,
  ChargeGroupBookingCancellationFeeModalState
> {
  state = { step: 1, canManuallyClose: true, title: '', startDateTime: null, isLoading: false };

  renderView = () => {
    const { step } = this.state;
    const { booking } = this.props;
    const { billingTotal, billingLineItems } = booking;
    const total = billingLineItems
      .filter(
        (billingItem) =>
          (billingItem.claimType !== ClaimType.NON_FACE_TO_FACE &&
            billingItem.supportItemNumber !== '04_599_0136_6_1' &&
            billingItem.supportItemNumber !== '10_599_0133_5_3') ||
          !billingItem.isAutoGenerated,
      )
      .reduce((total, lineItem) => total + Number(lineItem.billingTotal), 0);
    if (step === 1) {
      return (
        <div className="anim-fade-in">
          <Paragraph>Are you sure you want to charge a cancellation fee for this booking?</Paragraph>
          <Paragraph>
            The total cancellation fee for this booking is:
            <br />
            {CommonUtils.formatPrice(total)}
          </Paragraph>
          <Paragraph>This booking will have to be approved before it can be sent to payments.</Paragraph>
          <ActionModalFooter>
            <GhostButton className="mr-medium" size="large" onClick={this.onCloseModal} disabled={this.state.isLoading}>
              Cancel
            </GhostButton>
            <PrimaryButton size="large" icon="check" onClick={this.onAccept} disabled={this.state.isLoading}>
              Charge cancellation fee
            </PrimaryButton>
          </ActionModalFooter>
        </div>
      );
    }

    if (step === 2) {
      return (
        <div className="anim-slide-right">
          <Paragraph>You have successfully elected to charge a cancellation fee for this booking.</Paragraph>

          <ActionModalFooter>
            <PrimaryButton size="large" onClick={this.onCloseModal}>
              Close
            </PrimaryButton>
          </ActionModalFooter>
        </div>
      );
    }
  };

  componentDidUpdate(prevProps) {
    if (prevProps.isOpen !== this.props.isOpen) {
      const { booking } = this.props;
      this.setState({ step: 1, title: 'Charge cancellation fee' });
    }
  }

  onAccept = async () => {
    const { booking } = this.props;
    try {
      this.setState({ canManuallyClose: false, isLoading: true });
      await this.props.doChargeGroupBookings({
        serviceId: booking.serviceId,
        serviceDateTimeId: booking.serviceDateTimeId,
        bookingIds: [booking.bookingId],
      });
      this.setState({ step: 2, canManuallyClose: true, title: 'Cancellation fee applied', isLoading: false });
    } catch (e) {
      this.setState({ canManuallyClose: true, isLoading: false });
      notification.error({ message: 'Oops, something went wrong, please try again.' });
    }
  };

  onCloseModal = () => {
    const { onClose } = this.props;
    this.setState({ step: 1, canManuallyClose: true, title: '' }, onClose);
  };

  render() {
    let { isOpen } = this.props;
    const { title } = this.state;
    return (
      <ActionModal
        isOpen={isOpen}
        title={title}
        width="medium"
        onClose={this.onCloseModal}
        canCloseOutside={this.state.canManuallyClose}
        showCloseButton={this.state.canManuallyClose}
        verticalAlignment="highest"
      >
        <div>{this.renderView()}</div>
      </ActionModal>
    );
  }
}
